<template>
  <div class="vh-100 vw-100 d-flex justify-content-center align-items-center">
    <div class="logo-preloader mb-5">
      <div>
        <img
          src="/src/assets/images/dg-loader-logo.png"
          class="logo"
          alt="Preloader Logo"
        />
      </div>
      <div>
        <div class="spinner-border text-white loader" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.logo-preloader > div {
  position: absolute;
  left: calc(50% - 2.5rem);
  top: calc(50% - 2.5rem);
}
.logo {
  width: 5.4rem;
  height: 5.4rem;
  top: -3px;
  left: -3px;
  position: absolute;
}
.loader {
  width: 5rem;
  height: 5rem;
}
</style>
